import type { AppDispatch } from 'store/types';
import { kewloxApi } from './kewloxApi';
import type { InstructionsIndex } from './printing/instructionsTypes';

export const fetchInstructionsIndex = async (
  dispatch: AppDispatch,
): Promise<InstructionsIndex> => {
  const action = dispatch(kewloxApi.endpoints.getInstructionsIndex.initiate());

  try {
    const data = await action.unwrap();
    return data ?? [];
  } finally {
    if (typeof action.unsubscribe === 'function') {
      action.unsubscribe();
    }
  }
};
